import {
  RISK_RATING_CRITICAL,
  RISK_RATING_HIGH,
  RISK_RATING_LOW,
  RISK_RATING_MED,
  RISK_RATING_UNCLASSIFIED,
  VULN_NAME_BLIND_SQLI,
  VULN_NAME_CSRF,
  VULN_NAME_DOM_XSS,
  VULN_NAME_IDOR,
  VULN_NAME_REFLECTED_XSS,
  VULN_NAME_STORED_XSS,
  VULN_NAME_UNCLASSIFIED,
  VULN_NAME_UNION_SQLI,
  VULN_STATUS_RISK_ACCEPTED,
  VULN_STATUS_FIXED,
  VULN_STATUS_NONE,
  VULN_STATUS_OPEN,
} from "../constants/definitions";

/*********************************/
/*       SCORING FUNCTIONS       */
/*********************************/

// Get Score for Phase - as a way to sort
export function getRiskRatingScore(riskRating: string): number {
  const uppercaseRiskRating = riskRating.toUpperCase();

  if (RISK_RATING_UNCLASSIFIED.toUpperCase() === uppercaseRiskRating) {
    return 0;
  }
  if (RISK_RATING_LOW.toUpperCase() === uppercaseRiskRating) {
    return 1;
  }
  if (RISK_RATING_MED.toUpperCase() === uppercaseRiskRating) {
    return 2;
  }
  if (RISK_RATING_HIGH.toUpperCase() === uppercaseRiskRating) {
    return 3;
  }
  if (RISK_RATING_CRITICAL.toUpperCase() === uppercaseRiskRating) {
    return 4;
  }

  return 0;
}

// Get Score for Vuln Type - as a way to sort
export function getVulnTypeScore(vulntype: string): number {
  const uppercaseVulnType = vulntype.toUpperCase();

  if (VULN_NAME_CSRF.toUpperCase() === uppercaseVulnType) {
    return 1;
  }
  if (VULN_NAME_DOM_XSS.toUpperCase() === uppercaseVulnType) {
    return 2;
  }
  if (VULN_NAME_REFLECTED_XSS.toUpperCase() === uppercaseVulnType) {
    return 3;
  }
  if (VULN_NAME_STORED_XSS.toUpperCase() === uppercaseVulnType) {
    return 4;
  }
  if (VULN_NAME_BLIND_SQLI.toUpperCase() === uppercaseVulnType) {
    return 5;
  }
  if (VULN_NAME_UNION_SQLI.toUpperCase() === uppercaseVulnType) {
    return 6;
  }
  if (VULN_NAME_IDOR.toUpperCase() === uppercaseVulnType) {
    return 7;
  }
  if (VULN_NAME_UNCLASSIFIED.toUpperCase() === uppercaseVulnType) {
    return 100;
  }

  return 0;
}

// Get Score for status type
export function getVulnStatusScore(status: string): number {
  const upperCaseStatus = status.toUpperCase();

  if (VULN_STATUS_OPEN.toUpperCase() === upperCaseStatus) {
    return 1;
  }
  if (VULN_STATUS_RISK_ACCEPTED.toUpperCase() === upperCaseStatus) {
    return 2;
  }
  if (VULN_STATUS_FIXED.toUpperCase() === upperCaseStatus) {
    return 3;
  }
  if (VULN_STATUS_NONE.toUpperCase() === upperCaseStatus) {
    return 4;
  }

  return 0;
}
